import { render } from "./TestReportSkinData.vue?vue&type=template&id=7dd6389e&scoped=true&ts=true"
import script from "./TestReportSkinData.vue?vue&type=script&lang=ts"
export * from "./TestReportSkinData.vue?vue&type=script&lang=ts"

import "./TestReportSkinData.vue?vue&type=style&index=0&id=7dd6389e&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dd6389e"]])

export default __exports__